/**
 * Normalizes correct_answer values (which can be a numeric string index '0'-'3',
 * 1-based index '1'-'4', Bengali options 'ক'-'ঘ', or English letters 'A'-'D')
 * into a safe 0-based integer index (0 to 3).
 */
export function normalizeCorrectAnswer(correctAnswer: string | number | undefined | null): number {
  if (correctAnswer === undefined || correctAnswer === null) {
    return 0;
  }
  
  const ans = String(correctAnswer).trim().toLowerCase();
  
  // Directly matches 0-based index
  if (ans === '0' || ans === '1' || ans === '2' || ans === '3') {
    return parseInt(ans, 10);
  }
  
  // Mapping options
  const map: Record<string, number> = {
    // Bengali letters mapping
    'ক': 0,
    'খ': 1,
    'গ': 2,
    'ঘ': 3,
    // English letters mapping (lowercase)
    'a': 0,
    'b': 1,
    'c': 2,
    'd': 3,
    // 1-based index numeric mappings
    '1': 0,
    '2': 1,
    '3': 2,
    '4': 3
  };
  
  if (map[ans] !== undefined) {
    return map[ans];
  }
  
  // Safe numeric parse as final fallback
  const parsed = parseInt(ans, 10);
  if (!isNaN(parsed)) {
    if (parsed >= 1 && parsed <= 4) {
      return parsed - 1;
    }
    return parsed;
  }
  
  return 0;
}
